const date = new Date()
const firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)

function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}

const filtriStoricoVendite = {
    state: {
        filters: {
            search: '',
            from: formatDate(firstDay),
            to: formatDate(lastDay),
            kind: 'Tutte',
            payment: 'Tutti',
            user: 'Tutti',
            invoice: null,
            b2b: null,
            coffee: null,
            gift: null,
            points_sh: null
        }
    },
    mutations: {
        SET_FILTRI_STORICO_VENDITE_SEARCH(state, payload) {
            state.filters.search = payload
        },
        SET_FILTRI_STORICO_VENDITE_FROM(state, payload) {
            state.filters.from = payload
        },
        SET_FILTRI_STORICO_VENDITE_TO(state, payload) {
            state.filters.to = payload
        },
        SET_FILTRI_STORICO_VENDITE_KIND(state, payload) {
            state.filters.kind = payload
        },
        SET_FILTRI_STORICO_VENDITE_PAYMENT(state, payload) {
            state.filters.payment = payload
        },
        SET_FILTRI_STORICO_VENDITE_USER(state, payload) {
            state.filters.user = payload
        },
        SET_FILTRI_STORICO_VENDITE_INVOICE(state, payload) {
            state.filters.invoice = payload
        },
        SET_FILTRI_STORICO_VENDITE_B2B(state, payload) {
            state.filters.b2b = payload
        },
        SET_FILTRI_STORICO_VENDITE_COFFEE(state, payload) {
            state.filters.coffee = payload
        },
        SET_FILTRI_STORICO_VENDITE_GIFT(state, payload) {
            state.filters.gift = payload
        },
        SET_FILTRI_STORICO_VENDITE_POINTS_SH(state, payload) {
            state.filters.points_sh = payload
        },
        RESET_FILTRI_STORICO_VENDITE(state) {
            state.filters = {
                from: state.filters.from,
                to: state.filters.to,
                kind: 'Tutte',
                user: 'Tutti',
                invoice: null,
                b2b: null,
                coffee: null,
                gift: null,
                points_sh: null
            }
        }
    },
    getters: {
        getFiltriStoricoVendite: state => state.filters,
    }
}

export default filtriStoricoVendite